import { render, staticRenderFns } from "./AuthSuccessErrorPage.vue?vue&type=template&id=95378ed4&"
import script from "./AuthSuccessErrorPage.vue?vue&type=script&lang=js&"
export * from "./AuthSuccessErrorPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthSuccessErrorPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95378ed4')) {
      api.createRecord('95378ed4', component.options)
    } else {
      api.reload('95378ed4', component.options)
    }
    module.hot.accept("./AuthSuccessErrorPage.vue?vue&type=template&id=95378ed4&", function () {
      api.rerender('95378ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/pages/AuthSuccessErrorPage.vue"
export default component.exports